import { motion } from "framer-motion";
import { Check, Plus } from "lucide-react";
import { Icon } from "@/advisor/icons";
import { useAdvisor } from "@/advisor/AdvisorContext";

export const infoLabel = (sol) => (sol.demo_type === "qr" ? "Demo" : sol.has_demo ? "Necə işləyir?" : "Ətraflı");

export const SolutionCard = ({ sol, index, onInfo }) => {
  const { state, toggleSelect } = useAdvisor();
  const added = state.selected.includes(sol.slug);

  return (
    <motion.div
      initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: index * 0.07 }}
      className={`adv-card p-5 flex flex-col gap-4 transition-colors ${added ? "border-[#D6AD62]/50 bg-[#D6AD62]/[0.04]" : "hover:bg-[#262522]/60"}`}
      data-testid={`solution-card-${sol.slug}`}
    >
      <div className="flex items-start gap-3">
        <span className="h-12 w-12 shrink-0 rounded-xl bg-gradient-to-br from-[#D6AD62]/25 to-[#B98B42]/20 text-[#F3D592] grid place-items-center">
          <Icon name={sol.icon} className="h-6 w-6" />
        </span>
        <div className="min-w-0">
          <div className="text-xs text-[#8b867c] font-mono">{String(index + 1).padStart(2, "0")} · {sol.category}</div>
          <h4 className="text-lg font-semibold leading-tight mt-0.5">{sol.name}</h4>
        </div>
      </div>
      <div className="flex-1">
        <div className="text-xs uppercase tracking-wider text-[#F3D592]/80 font-semibold mb-1">Nə verir?</div>
        <p className="text-sm text-[#cfc9bd] leading-relaxed">{sol.short_desc}</p>
      </div>
      <div className="grid grid-cols-2 gap-2">
        <button className="adv-btn-ghost px-3 text-sm" onClick={() => onInfo(sol)} data-testid={`btn-how-it-works-${sol.slug}`}>
          {infoLabel(sol)}
        </button>
        <button
          className={`adv-btn-base px-3 text-sm ${added ? "bg-[#D6AD62]/15 text-[#F3D592] border border-[#D6AD62]/50" : "bg-[#D6AD62] text-[#111110] hover:bg-[#e2bd77]"}`}
          onClick={() => toggleSelect(sol.slug)}
          data-testid={`btn-add-to-project-${sol.slug}`}
        >
          {added ? <><Check className="h-4 w-4" /> Əlavə edildi</> : <><Plus className="h-4 w-4" /> Layihəmə</>}
        </button>
      </div>
    </motion.div>
  );
};
